import React from 'react';
import { Info, BarChart3 } from 'lucide-react';

const WorkflowStatsView = ({ hasStats = false }) => (
  <div className="pointer-events-none absolute left-4 top-4 z-20 max-w-md space-y-2" data-testid="workflow-stats-view">
    <div className="rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 shadow-md">
      <div className="flex items-start gap-2">
        <Info size={16} className="mt-0.5 shrink-0 text-slate-500" />
        <div>
          <p>
            Workflow is not editable in <strong>Stats view</strong>.
          </p>
          <p className="mt-1 text-slate-500">
            <strong>Note:</strong> Stats are only available for the last 30 days.
          </p>
        </div>
      </div>
    </div>
    {!hasStats && (
      <div className="rounded-xl border border-slate-200 bg-white p-8 text-center shadow-md">
        <BarChart3 size={32} className="mx-auto mb-3 text-slate-300" />
        <p className="font-medium text-slate-700">No Activity Yet</p>
        <p className="mt-1 text-sm text-slate-500">
          Publish this workflow to start collecting performance stats.
        </p>
      </div>
    )}
  </div>
);

export default WorkflowStatsView;
